import { render, staticRenderFns } from "./VerticalResourceWorkspace.vue?vue&type=template&id=4aa4b14f&scoped=true"
import script from "./VerticalResourceWorkspace.vue?vue&type=script&lang=js"
export * from "./VerticalResourceWorkspace.vue?vue&type=script&lang=js"
import style0 from "./VerticalResourceWorkspace.vue?vue&type=style&index=0&id=4aa4b14f&prod&scoped=true&lang=css"
import style1 from "./VerticalResourceWorkspace.vue?vue&type=style&index=1&id=4aa4b14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4b14f",
  null
  
)

export default component.exports